export type RechargePackage = {
  id: number | string;
  amount: number | string;
  credits: number | string;
};

export const formatCreditAmount = (amount: number | string): string => {
  const numericAmount = Number(String(amount).replace(/[^0-9.]/g, ''));
  if (!Number.isFinite(numericAmount)) {
    return String(amount || '');
  }

  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(numericAmount);
};

export const formatCredits = (credits: number | string): string => {
  const numericCredits = Number(credits);
  if (!Number.isFinite(numericCredits)) {
    return String(credits || '0');
  }

  return new Intl.NumberFormat('en-US').format(numericCredits);
};
